import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';

import mediaByScene from './mediaByScene';
import scene from './scene';
import ui from './ui';
import skills from './skills';
import nav from './nav';

// index.js in React: https://stackoverflow.com/questions/44092341/how-do-index-js-files-work-in-react-component-directories

const rootReducer = combineReducers({
    scene,
    mediaByScene,
    router,
    ui,
    skills,
    nav
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js